import { isAxiosError } from 'axios';
import { axiosAuth } from '@/axios';
import { Endpoints } from '@/enums';

export const sendForgotPasswordEmail = async (
  email: string
): Promise<unknown> => {
  try {
    const res = await axiosAuth.post(Endpoints.ForgotPassword, {
      email,
    });
    return res;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
